import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=fbef656c&scoped=true&"
import script from "./LogoutView.vue?vue&type=script&lang=js&"
export * from "./LogoutView.vue?vue&type=script&lang=js&"
import style0 from "./LogoutView.vue?vue&type=style&index=0&id=fbef656c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbef656c",
  null
  
)

export default component.exports